import { render, staticRenderFns } from "./PreenrollmentWidget.vue?vue&type=template&id=897f1d74"
import script from "./PreenrollmentWidget.vue?vue&type=script&lang=ts"
export * from "./PreenrollmentWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports